// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAlloysPartnersShopifyAppGroupIdBridgesResult = objectOf({
  bridges: arrayOf(objectOf({ id: string, external_id: string, app_group_id: maybe(string, true) })),
});
